import React from 'react';
import ModalImageComponent from '@components/modals/image/modalImageComponent';

import AppContext from '@services/Context';
import I18n from '../../../../../../i18n';

interface IProp {
    actionText: string
    url: string
}

class SampleImageComponent extends React.Component<IProp, {}> {

    render(): JSX.Element {
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <div>
                        <ModalImageComponent
                            urlPath={this.props.url}
                            actionText={this.props.actionText}
                            title={I18n.l('history.timeline.registerTask.label')}
                            actionButton={false}
                        />
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
};

export default SampleImageComponent;
